module.exports = __webpack_public_path__ + "img/jppdimg_mo5.e620b1f9.png";